import React from 'react';

import { Hash } from '@lyearn/icons';
import Emoji from '@/components/Emoji';
import { IconType } from '@/utils/icon';

import { DEFAULTS } from './consts';

function Icon({ icon, EmojiDefaultIcon }: { icon: string; EmojiDefaultIcon?: IconType }) {
  if (icon) {
    // @ts-ignore
    return <Emoji emoji={icon} {...DEFAULTS.Emoji} />;
  }

  const IconComp = EmojiDefaultIcon || Hash;

  return <IconComp {...DEFAULTS.Icon} />;
}

export default Icon;
